/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import type { Provider, TransactionRequest } from "@ethersproject/providers";
import type { PromiseOrValue } from "../../../common";
import type {
  ManagerLogic1,
  ManagerLogic1Interface,
} from "../../../contracts/manager/ManagerLogic1";

const _abi = [
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "who",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "usdtCost",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256[]",
        name: "earlyAccessIds",
        type: "uint256[]",
      },
    ],
    name: "BuyEarlyAccess",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "who",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "usdsAmount",
        type: "uint256",
      },
    ],
    name: "GetInvestmentReward",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "who",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "reward",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "bonus",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "stfToSelf",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "stfToDead",
        type: "uint256",
      },
    ],
    name: "GetReward",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "who",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "usdtAll",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "zbcUsdtPrice",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "usdtCost",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "zbcCost",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "investmentCredentialId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "usdsAmount",
        type: "uint256",
      },
    ],
    name: "Invest",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "who",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "usdsAmount",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "usdtAmount",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "usdtToColdWallet",
        type: "uint256",
      },
    ],
    name: "RedeemUsds",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "who",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "inviter",
        type: "address",
      },
    ],
    name: "Register",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "who",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "usds",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "power",
        type: "uint256",
      },
    ],
    name: "Stake",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "who",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "usdtAmount",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "usdsAmount",
        type: "uint256",
      },
    ],
    name: "UsdtPurchaseUsds",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "who",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "usds",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "usdsToBurn",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "power",
        type: "uint256",
      },
    ],
    name: "Withdraw",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "who",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "usdsAmount",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "ticketNumber",
        type: "uint256",
      },
    ],
    name: "WithdrawPromotionUsds",
    type: "event",
  },
  {
    stateMutability: "payable",
    type: "fallback",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "lp",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "lpUsdtPrice",
        type: "uint256",
      },
    ],
    name: "_lpToUsd",
    outputs: [
      {
        internalType: "uint256",
        name: "usd",
        type: "uint256",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "usd",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "stfUsdtPrice",
        type: "uint256",
      },
    ],
    name: "_usdToStf",
    outputs: [
      {
        internalType: "uint256",
        name: "stf",
        type: "uint256",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "usdtStfLpAmount",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "usdsStfLpPrice",
        type: "uint256",
      },
    ],
    name: "_usdsStfLpToUsd",
    outputs: [
      {
        internalType: "uint256",
        name: "usd",
        type: "uint256",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [],
    name: "accessControl",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "buyEarlyAccess",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "zbcPriceFixedPoint18",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "timestamp",
            type: "uint256",
          },
        ],
        internalType: "struct ManagerType.ZbcPriceParam",
        name: "param",
        type: "tuple",
      },
      {
        internalType: "uint256",
        name: "investUsdtAmount",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "investZbcAmount",
        type: "uint256",
      },
    ],
    name: "calcInvestCost",
    outputs: [
      {
        internalType: "uint256",
        name: "zbcCost",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "usdtCost",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "usdtAll",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "address",
            name: "who",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "usdsAmount",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "ticketNumber",
            type: "uint256",
          },
        ],
        internalType: "struct ManagerType.WithdrawPromotionParam",
        name: "param",
        type: "tuple",
      },
    ],
    name: "calcWithdrawPromotionParamDigest",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "zbcPriceFixedPoint18",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "timestamp",
            type: "uint256",
          },
        ],
        internalType: "struct ManagerType.ZbcPriceParam",
        name: "param",
        type: "tuple",
      },
    ],
    name: "calcZbcPriceParamDigest",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256[]",
        name: "earlyAccessIds",
        type: "uint256[]",
      },
    ],
    name: "earlyAccessRedeemInvestmentCredential",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "address",
            name: "who",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "usdtAll",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "investmentCredentialId",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "usdsAmount",
            type: "uint256",
          },
        ],
        internalType: "struct ManagerType.FakeEmitInvest[]",
        name: "params",
        type: "tuple[]",
      },
    ],
    name: "fakeEmitInvest",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256[]",
        name: "investmentCredentialIds",
        type: "uint256[]",
      },
    ],
    name: "getInvestmentReward",
    outputs: [
      {
        internalType: "uint256[]",
        name: "",
        type: "uint256[]",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "getWithdrawPromotionParamTypeHash",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [],
    name: "getZbcPriceParamTypeHash",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "zbcPriceFixedPoint18",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "timestamp",
            type: "uint256",
          },
        ],
        internalType: "struct ManagerType.ZbcPriceParam",
        name: "param",
        type: "tuple",
      },
      {
        components: [
          {
            internalType: "bytes32",
            name: "r",
            type: "bytes32",
          },
          {
            internalType: "bytes32",
            name: "s",
            type: "bytes32",
          },
          {
            internalType: "uint8",
            name: "v",
            type: "uint8",
          },
        ],
        internalType: "struct ManagerType.Signature",
        name: "signature",
        type: "tuple",
      },
      {
        internalType: "uint256",
        name: "investUsdtAmount",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "investZbcAmount",
        type: "uint256",
      },
    ],
    name: "invest",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "address",
            name: "who",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "usdsValue",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "startTimestamp",
            type: "uint256",
          },
        ],
        internalType: "struct ManagerType.MintInvestmentParam[]",
        name: "params",
        type: "tuple[]",
      },
    ],
    name: "mintInvestment",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "who",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "usdsAmount",
        type: "uint256",
      },
    ],
    name: "mintUsdsAuthXXX",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "usdsAmount",
        type: "uint256",
      },
    ],
    name: "redeemUsds",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "inviterCode",
        type: "bytes32",
      },
    ],
    name: "register",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "who",
        type: "address",
      },
      {
        internalType: "bytes32",
        name: "inviterCode",
        type: "bytes32",
      },
    ],
    name: "registerAuth",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newAssociatedOperator",
        type: "address",
      },
      {
        internalType: "bool",
        name: "flag",
        type: "bool",
      },
    ],
    name: "setAssociatedOperator",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "usdtAmount",
        type: "uint256",
      },
    ],
    name: "usdtPurchaseUsds",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "address",
            name: "who",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "usdsAmount",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "ticketNumber",
            type: "uint256",
          },
        ],
        internalType: "struct ManagerType.WithdrawPromotionParam",
        name: "param",
        type: "tuple",
      },
      {
        components: [
          {
            internalType: "bytes32",
            name: "r",
            type: "bytes32",
          },
          {
            internalType: "bytes32",
            name: "s",
            type: "bytes32",
          },
          {
            internalType: "uint8",
            name: "v",
            type: "uint8",
          },
        ],
        internalType: "struct ManagerType.Signature",
        name: "signature",
        type: "tuple",
      },
    ],
    name: "withdrawPromotion",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    stateMutability: "payable",
    type: "receive",
  },
] as const;

const _bytecode =
  "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";

type ManagerLogic1ConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: ManagerLogic1ConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class ManagerLogic1__factory extends ContractFactory {
  constructor(...args: ManagerLogic1ConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  override deploy(
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): Promise<ManagerLogic1> {
    return super.deploy(overrides || {}) as Promise<ManagerLogic1>;
  }
  override getDeployTransaction(
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  override attach(address: string): ManagerLogic1 {
    return super.attach(address) as ManagerLogic1;
  }
  override connect(signer: Signer): ManagerLogic1__factory {
    return super.connect(signer) as ManagerLogic1__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): ManagerLogic1Interface {
    return new utils.Interface(_abi) as ManagerLogic1Interface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): ManagerLogic1 {
    return new Contract(address, _abi, signerOrProvider) as ManagerLogic1;
  }
}
